//Author June Leow
//Date Mar 22nd, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import {Card, CardHeader, CardBody, Input} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import MySelect from '../../../util/my-select';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {

};


const exteriorDeficiencyNameEnum = [
  {value:'FOUNDATION', label:'Foundation'}, 
  {value:'ROOF', label:'Roof'}, 
  {value:'SIDING', label:'Siding'}, 
  {value:'FASCIA', label:'Fascia'}, 
  {value:'WINDOWS', label:'Windows'}, 
  {value:'DOORS', label:'Doors'}, 
  {value:'GUTTERS_DOWNSPOUTS', label:'Gutters Downspouts'}, 
  {value:'EAVES', label:'Eaves'}, 
  {value:'CHIMNEY', label:'Chimney'}, 
  {value:'PORCH', label:'Porch'}, 
  {value:'PATIO', label:'Patio'}, 
  {value:'DECK', label:'Deck'}, 
  {value:'BALCONY', label:'Balcony'}, 
  {value:'ENTRY_STAIRS', label:'Entry Stairs'}, 
  {value:'CARPORT', label:'Carport'}, 
  {value:'DRIVEWAY', label:'Driveway'}, 
  {value:'INCOMPLETE_LANDSCAPING', label:'Incomplete Landscaping'}, 
  {value:'OTHER', label:'Other'}, 
  {value:'EXTERIOR_WALLS', label:'Exterior Walls'}, 
  {value:'NONE_OBSERVED', label:'None Observed'}, 
];

const exteriorDeficiencyTypeEnum = [
  {value:'EXCESSIVE_WEAR', label:'Excessive Wear'}, 
  {value:'DAMAGE', label:'Damage'}, 
  {value:'EVIDENCE_OF_INFESTATION', label:'Evidence of Infestation'}, 
  {value:'MISSING', label:'Missing'}, 
  {value:'OTHER', label:'Other'}, 
];

const exteriorDeficiencyDetailFoundationEnum = [
  {value:'ERODED_MATERIAL', label:'Eroded Material'}, 
  {value:'CRACKING', label:'Cracking'}, 
  {value:'SETTLEMENT', label:'Settlement'}, 
  {value:'EVIDENCE_OF_MOISTURE', label:'Evidence of Moisture'}, 
  {value:'SEEPAGE', label:'Seepage'}, 
  {value:'INFESTATION', label:'Infestation'}, 
  {value:'LEANING_OR_BOWING_WALLS', label:'Leaning or Bowing Walls'}, 
  {value:'HEAVING', label:'Heaving'}, 
  {value:'OTHER', label:'Other'}
];

const exteriorDeficiencyDetailExteriorWallsEnum = [
  {value:'ERODED_MATERIAL', label:'Eroded Material'}, 
  {value:'CRACKING', label:'Cracking'}, 
  {value:'HOLES', label:'Holes'}, 
  {value:'DRY_ROT', label:'Dry Rot'}, 
  {value:'MOISTURE_ROT', label:'Moisture Rot'}, 
  {value:'SETTLEMENT', label:'Settlement'}, 
  {value:'WIND_DAMAGE', label:'Wind Damage'}, 
  {value:'MISSING_MATERIAL', label:'Missing Material'}, 
  {value:'OTHER', label:'Other'}, 
];

const exteriorDeficiencyDetailRoofSurfaceEnum = [
  {value:'ERODED_MATERIAL', label:'Eroded Material'}, 
  {value:'CRACKING', label:'Cracking'}, 
  {value:'TARP_ON_ROOF', label:'Tarp on Roof'}, 
  {value:'LEAK_EVIDENT', label:'Leak Evident'}, 
  {value:'MISSING_MATERIAL', label:'Missing Material'}, 
  {value:'WOOD_ROT', label:'Wood Rot'}, 
  {value:'SOFFIT_DAMAGE', label:'Soffit Damage'}, 
  {value:'FASCIA_DAMAGE', label:'Fascia Damage'}, 
  {value:'OTHER', label:'Other'}, 
];

const exteriorDeficiencyDetailGuttersandDownspoutsEnum = [
  {value:'ERODED_MATERIAL', label:'Eroded Material'}, 
  {value:'CRACKING', label:'Cracking'}, 
  {value:'MISSING_DOWNSPOUTS', label:'Missing Downspouts'}, 
  {value:'DAMAGED', label:'Damaged'}, 
  {value:'LEAKING', label:'Leaking'}, 
  {value:'INFESTATION', label:'Infestation'}, 
  {value:'IMPROPER_FLOW', label:'Improper Flow'}, 
  {value:'MISSING_GUTTER', label:'Missing Gutter'}, 
  {value:'OTHER', label:'Other'}, 
];

const exteriorDeficiencyDetailWindowsEnum = [
  {value:'CRACKING', label:'Cracking'}, 
  {value:'MISSING_WINDOW_PANE', label:'Missing Window Pane'}, 
  {value:'DRY_ROT', label:'Dry Rot'}, 
  {value:'BROKEN_GLASS', label:'Broken Glass'}, 
  {value:'BOARDED_UP', label:'Boarded Up'}, 
  {value:'MISSING_WINDOW', label:'Missing Window'}, 
  {value:'EXPOSED_WOOD', label:'Exposed Wood'}, 
  {value:'STORM_SASH_DAMAGE', label:'Storm Sash Damage'}, 
  {value:'THERMOPANE_DAMAGE', label:'Thermopane Damage'}, 
  {value:'OTHER', label:'Other'}
];

const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const ExteriorDeficiencies  = (props)=>{
  const controller = new AbortController();

  const [, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const getDeficiencyDetailFoundationLabel = (value)=>{
    for(let i=0;i<exteriorDeficiencyDetailFoundationEnum.length;i++){
      if(exteriorDeficiencyDetailFoundationEnum[i].value===value)
        return exteriorDeficiencyDetailFoundationEnum[i].label;
    }

    return value;
  }

  const getDeficiencyDetailWallLabel = (value)=>{
    for(let i=0;i<exteriorDeficiencyDetailExteriorWallsEnum.length;i++){
      if(exteriorDeficiencyDetailExteriorWallsEnum[i].value===value)
        return exteriorDeficiencyDetailExteriorWallsEnum[i].label;
    }

    return value;
  }

  const getDeficiencyDetailRoofSurfaceLabel = (value)=>{
    for(let i=0;i<exteriorDeficiencyDetailRoofSurfaceEnum.length;i++){
      if(exteriorDeficiencyDetailRoofSurfaceEnum[i].value===value)
        return exteriorDeficiencyDetailRoofSurfaceEnum[i].label;
    }

    return value;
  }

  const getDeficiencyDetailGutterDownspoutLabel = (value)=>{
    for(let i=0;i<exteriorDeficiencyDetailGuttersandDownspoutsEnum.length;i++){
      if(exteriorDeficiencyDetailGuttersandDownspoutsEnum[i].value===value)
        return exteriorDeficiencyDetailGuttersandDownspoutsEnum[i].label;
    }

    return value;
  }

  const getDeficiencyDetailWindowLabel = (value)=>{
    for(let i=0;i<exteriorDeficiencyDetailWindowsEnum.length;i++){
      if(exteriorDeficiencyDetailWindowsEnum[i].value===value)
        return exteriorDeficiencyDetailWindowsEnum[i].label;
    }

    return value;
  }

  

  const getCompressRatio = (size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  const updateFileDescription = (index, index2, field, description) =>{
    let newUPD = Object.assign({}, props.upd);
    let exteriorDeficiencies = newUPD.property.buildings[props.index].exteriorDeficiencies.slice();
    let target = exteriorDeficiencies[index][field]?exteriorDeficiencies[index][field]:[];
    if(target &&  target[index2]){
      target[index2].description = description;
    }

    newUPD.property.buildings[props.index].exteriorDeficiencies = exteriorDeficiencies;
    props.update(newUPD);
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop = (acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    // let limit = 3;
    //
    // if(type==='Floor Plan')
    //   limit = 1;
    //
    // if(props[field].length+ acceptedFiles.length>limit){
    //   let numberOfAvailable = limit - props[field].length;
    //   acceptedFiles = acceptedFiles.slice(0, numberOfAvailable);
    //   showMessage('error', 'Maximum number of photo uploaded and could not accept any more photos.');
    // }

    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let exteriorDeficiencies = newUPD.property.buildings[props.index].exteriorDeficiencies.slice();
   
                let target = exteriorDeficiencies[index][field]?exteriorDeficiencies[index][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:exteriorDeficiencies[index].ID, description:description});
                exteriorDeficiencies[index][field] = target;
                newUPD.property.buildings[props.index].exteriorDeficiencies = exteriorDeficiencies;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const removeFile = (field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let exteriorDeficiencies = newUPD.property.buildings[props.index].exteriorDeficiencies.slice();
    let target = exteriorDeficiencies[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        exteriorDeficiencies[index][field] = target;
        newUPD.property.buildings[props.index].exteriorDeficiencies = exteriorDeficiencies;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      exteriorDeficiencies[index][field] = target;
      newUPD.property.buildings[props.index].exteriorDeficiencies = exteriorDeficiencies;
      props.update(newUPD);
    }
  }

  const getExteriorDeficienciesLabel = (value)=>{
    console.log(value)
    for(let i=0;i<exteriorDeficiencyNameEnum.length;i++){
      if(exteriorDeficiencyNameEnum[i].value===value)
        return exteriorDeficiencyNameEnum[i].label;
    }

    return value;
  }

  const removeExteriorDeficienciesDetail = (index, index2, field)=>{
    let newUPD = Object.assign({}, props.upd);
    let exteriorDeficiencies = newUPD.property.buildings[props.index].exteriorDeficiencies.slice();
    let target = exteriorDeficiencies[index][field].slice();
    target.splice(index2, 1);
    exteriorDeficiencies[index][field] = target;
    newUPD.property.buildings[props.index].exteriorDeficiencies = exteriorDeficiencies;
    props.update(newUPD);
  }

  const updateExteriorDeficienciesDetail = (index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let exteriorDeficiencies = newUPD.property.buildings[props.index].exteriorDeficiencies.slice();
    
    switch(field){
      case 'exteriorDeficiencyDetailFoundation':
      case 'exteriorDeficiencyDetailExteriorWalls':
      case 'exteriorDeficiencyDetailRoofSurface':
      case 'exteriorDeficiencyDetailGuttersandDownspouts':
      case 'exteriorDeficiencyDetailWindows':
        let target = exteriorDeficiencies[index][field]?exteriorDeficiencies[index][field].slice():[];
        if(target.indexOf(value)===-1)
          target.push(value);
        exteriorDeficiencies[index][field] = target;
        break;
      default:
        exteriorDeficiencies[index][field] = value;
        break;
    }
    
    newUPD.property.buildings[props.index].exteriorDeficiencies = exteriorDeficiencies;
    props.update(newUPD);
  }

  const updateExteriorDeficiencies = (value)=>{
    let newUPD = Object.assign({}, props.upd);
    let exteriorDeficiencies = newUPD.property.buildings[props.index].exteriorDeficiencies?newUPD.property.buildings[props.index].exteriorDeficiencies.slice():[];

    if(value==='NONE_OBSERVED'){
      exteriorDeficiencies = [{exteriorDeficiencyName:value}];
    }
    else{
      for(let i=0;i<exteriorDeficiencies.length;i++){
        if(exteriorDeficiencies[i].exteriorDeficiencyName==='NONE_OBSERVED'){
          exteriorDeficiencies = [];
          break;
        }
      }
   
      exteriorDeficiencies.push({exteriorDeficiencyName:value, imageExteriorDeficiency:[]});
    }
    
    newUPD.property.buildings[props.index].exteriorDeficiencies = exteriorDeficiencies;
    props.update(newUPD);
  }

  const removeExteriorDeficiencies = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let exteriorDeficiencies = newUPD.property.buildings[props.index].exteriorDeficiencies.slice();
    exteriorDeficiencies.splice(index, 1);
    newUPD.property.buildings[props.index].exteriorDeficiencies = exteriorDeficiencies;
    props.update(newUPD);
  }

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }

  //render
  return (<div>
    <label>{!props.disabled?<font color="red">*</font>:null}What type of exterior item(s) or component(s) were observed that have deferred maintenance requiring repairs? {generateTooltip('exteriorDeficiencyName', 'User to identify any exterior item(s) or component(s) that have deferred maintenance are either damaged or in need of requiring repair. ')}</label>
    <MySelect
      type="select"
      required={!props.disabled}
      disabled={props.disabled}
      style={props.disabled?disabledStyling:{}}
      value={props.upd.property.buildings[props.index].exteriorDeficiencies && props.upd.property.buildings[props.index].exteriorDeficiencies.length>0?" ":""}
      onChange={(v)=>updateExteriorDeficiencies(v)}
      options={exteriorDeficiencyNameEnum}
    />
    <br/>
    {
      props.upd.property.buildings[props.index].exteriorDeficiencies.map(
        (exteriorDeficiency, index)=>{
          if(exteriorDeficiency.exteriorDeficiencyName==='NONE_OBSERVED'){
            return <div key={index} style={{marginTop:'15px'}}>
              <b>None Observed</b>
            </div>
          }

          return (
            <div key={index} style={{marginTop:"10px"}}>
              <Card>
                <CardHeader>
                  <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeExteriorDeficiencies(index)}/> {getExteriorDeficienciesLabel(exteriorDeficiency.exteriorDeficiencyName)} Exterior Deficiency
                </CardHeader>
                <CardBody>
                  <label>{!props.disabled?<font color="red">*</font>:null}What type of damage or wear was observed for the item / component selected?</label>
                  <MySelect
                    type="select"
                    required={!props.disabled}
                    disabled={props.disabled}
                    style={props.disabled?disabledStyling:{}}
                    value={exteriorDeficiency.exteriorDeficiencyType}
                    onChange={(v)=>updateExteriorDeficienciesDetail(index, 'exteriorDeficiencyType', v)}
                    options={exteriorDeficiencyTypeEnum}
                  />
                  <br/>

                  {exteriorDeficiency.exteriorDeficiencyName==='FOUNDATION'?<div>
                    <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected.</label>
                    <MySelect
                      type="select"
                      required={!props.disabled}
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={exteriorDeficiency.exteriorDeficiencyDetailFoundation && exteriorDeficiency.exteriorDeficiencyDetailFoundation.length>0?" ":""}
                      onChange={(v)=>updateExteriorDeficienciesDetail(index,'exteriorDeficiencyDetailFoundation', v)}
                      options={exteriorDeficiencyDetailFoundationEnum}
                    />
                    <br/>
                    {
                      exteriorDeficiency.exteriorDeficiencyDetailFoundation?exteriorDeficiency.exteriorDeficiencyDetailFoundation.map(
                        (detail, index2)=>{
                          return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                            <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeExteriorDeficienciesDetail(index, index2, 'exteriorDeficiencyDetailFoundation')}/> {getDeficiencyDetailFoundationLabel(detail)}
                          </span>
                        }
                      ):null
                    }
                  </div>:null}

                  {exteriorDeficiency.exteriorDeficiencyName==='EXTERIOR_WALLS'?<div>
                    <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected.</label>
                    <MySelect
                      type="select"
                      required={!props.disabled}
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={exteriorDeficiency.exteriorDeficiencyDetailExteriorWalls && exteriorDeficiency.exteriorDeficiencyDetailExteriorWalls.length>0?" ":""}
                      onChange={(v)=>updateExteriorDeficienciesDetail(index,'exteriorDeficiencyDetailExteriorWalls', v)}
                      options={exteriorDeficiencyDetailExteriorWallsEnum}
                    />
                    <br/>
                    {
                      exteriorDeficiency.exteriorDeficiencyDetailExteriorWalls?exteriorDeficiency.exteriorDeficiencyDetailExteriorWalls.map(
                        (detail, index2)=>{
                          return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                            <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeExteriorDeficienciesDetail(index, index2, 'exteriorDeficiencyDetailExteriorWalls')}/> {getDeficiencyDetailWallLabel(detail)}
                          </span>
                        }
                      ):null
                    }
                  </div>:null}

                  {exteriorDeficiency.exteriorDeficiencyName==='ROOF'?<div>
                    <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected.</label>
                    <MySelect
                      type="select"
                      required={!props.disabled}
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={exteriorDeficiency.exteriorDeficiencyDetailRoofSurface && exteriorDeficiency.exteriorDeficiencyDetailRoofSurface.length>0?" ":""}
                      onChange={(v)=>updateExteriorDeficienciesDetail(index,'exteriorDeficiencyDetailRoofSurface', v)}
                      options={exteriorDeficiencyDetailRoofSurfaceEnum}
                    />
                    <br/>
                    {
                      exteriorDeficiency.exteriorDeficiencyDetailRoofSurface?exteriorDeficiency.exteriorDeficiencyDetailRoofSurface.map(
                        (detail, index2)=>{
                          return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                            <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeExteriorDeficienciesDetail(index, index2, 'exteriorDeficiencyDetailRoofSurface')}/> {getDeficiencyDetailRoofSurfaceLabel(detail)}
                          </span>
                        }
                      ):null
                    }
                  </div>:null}

                  {exteriorDeficiency.exteriorDeficiencyName==='GUTTERS_DOWNSPOUTS'?<div>
                    <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected.</label>
                    <MySelect
                      type="select"
                      required={!props.disabled}
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={exteriorDeficiency.exteriorDeficiencyDetailGuttersandDownspouts && exteriorDeficiency.exteriorDeficiencyDetailGuttersandDownspouts.length>0?" ":""}
                      onChange={(v)=>updateExteriorDeficienciesDetail(index,'exteriorDeficiencyDetailGuttersandDownspouts', v)}
                      options={exteriorDeficiencyDetailGuttersandDownspoutsEnum}
                    />
                    <br/>
                    {
                      exteriorDeficiency.exteriorDeficiencyDetailGuttersandDownspouts?exteriorDeficiency.exteriorDeficiencyDetailGuttersandDownspouts.map(
                        (detail, index2)=>{
                          return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                            <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeExteriorDeficienciesDetail(index, index2, 'exteriorDeficiencyDetailGuttersandDownspouts')}/> {getDeficiencyDetailGutterDownspoutLabel(detail)}
                          </span>
                        }
                      ):null
                    }
                  </div>:null}

                  {exteriorDeficiency.exteriorDeficiencyName==='WINDOWS'?<div>
                    <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the item / component selected.</label>
                    <MySelect
                      type="select"
                      required={!props.disabled}
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={exteriorDeficiency.exteriorDeficiencyDetailWindows && exteriorDeficiency.exteriorDeficiencyDetailWindows.length>0?" ":""}
                      onChange={(v)=>updateExteriorDeficienciesDetail(index,'exteriorDeficiencyDetailWindows', v)}
                      options={exteriorDeficiencyDetailWindowsEnum}
                    />
                    <br/>
                    {
                      exteriorDeficiency.exteriorDeficiencyDetailWindows?exteriorDeficiency.exteriorDeficiencyDetailWindows.map(
                        (detail, index2)=>{
                          return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                            <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeExteriorDeficienciesDetail(index, index2, 'exteriorDeficiencyDetailWindows')}/> {getDeficiencyDetailWindowLabel(detail)}
                          </span>
                        }
                      ):null
                    }
                  </div>:null}

                  <label>{!props.disabled?<font color="red">*</font>:null}Does the deficiency impact the safety, soundness or structural integrity of the structure?</label>
                  <MySelect
                    type="select"
                    required={!props.disabled}
                    disabled={props.disabled}
                    style={props.disabled?disabledStyling:{}}
                    value={exteriorDeficiency.exteriorDeficiencySeverity}
                    onChange={(v)=>updateExteriorDeficienciesDetail(index, 'exteriorDeficiencySeverity', v)}
                    options={[{label:"True", value:"True"}, {label:"False", value:"False"}]}
                  />
                  <br/>
                  <label>{!props.disabled?<font color="red">*</font>:null}Provide a concise description of each deficiency observed. {generateTooltip('exteriorDeficiencyDescription'+index, 'User to provide a concise text description of any deficiencies observed.')}</label>
                  <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={exteriorDeficiency.exteriorDeficiencyDescription} onChange={(e)=>updateExteriorDeficienciesDetail(index,'exteriorDeficiencyDescription', e.target.value)}/>

                  <div className="my-divider"/>
                  <br/>
                  <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of exterior deficiency</label>
                  <br/>
                  <input
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0, width:0 }}
                    value={exteriorDeficiency.imageExteriorDeficiency&&exteriorDeficiency.imageExteriorDeficiency.length>0?" ":""}
                    required={!props.disabled}
                  />
                  <div>
                    <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageExteriorDeficiency', exteriorDeficiency.exteriorDeficiencyName+'_EXTERIOR_DEFICIENCY', 0)}} className="my-dropzone">
                    {
                    ({getRootProps, getInputProps}) => (
                      <div
                        {...getRootProps({
                          className: 'my-dropzone',
                        })}
                      >
                        <input {...getInputProps()} />
                        <center>Choose files to upload</center>
                      </div>
                    )
                  }
                    </Dropzone>
                    {
                      !exteriorDeficiency.imageExteriorDeficiency?null:exteriorDeficiency.imageExteriorDeficiency.map(
                        (photo, index2)=>{
                          return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                            <div>
                              <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageExteriorDeficiency',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                            </div>
                            <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                            <div style={{marginTop:'5px'}}/>
                            {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageExteriorDeficiency', e.target.value)}/>
                            <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                          </div>
                        }
                      )
                    }
                  </div>
                </CardBody>
              </Card>
            </div>
          )
        }
      )
    }
    
  </div>);
}


export default ExteriorDeficiencies;